import storage from "@/utils/storageUtils";

const {authorizationCode, isA, isAM, manufacturer} = window.searchObj || {};

let authorization = '';

// 数据源key
export const headerManufacturerKey = 'MANUFACTURER_CODE_KEY';

// token key
export const authKey = 'fande';
export const authCodeIsUsedKey = 'AUTHCODEISUSEDKEY'

export const getAuthCodeIsUsed = ()=>storage.session.get(authCodeIsUsedKey) === authorizationCode;
export const saveUsedAuthCode = ()=>storage.session.set(authCodeIsUsedKey, authorizationCode);

export const setAuth = (auth)=>{
  authorization = auth;
  storage.local.set(authKey, auth);
}
export const getAuth = ()=>storage.local.get(authKey);
export const clearAuth = ()=>{
  authorization = '';
  storage.local.remove(authKey);
}
